import React, { useState, useEffect, useRef } from "react";
import { Modal, Header, Image, Input, Button, Popup, Dropdown } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import {
  addDataSet,
  getDatasets,
  getDocumentSuccess,
  AddRequestSuccess,
  DatasetUsersDataSuccess,
  createDocSettings,
  createPrompt,
  saveAssistantParameters,
} from "../../actions/dataConsoleAction";
import CardLoader from "../Pagination/CardLoader";
import "../../styles/Dataset.css";
import Loader from "../../components/Loader";
import DatasetLandingPage from "./DatasetLandingPage";
import { set } from "date-fns";
import { useParams, useLocation } from 'react-router-dom';
import ToggleButtonGroup from "../../uiComponents/ToggleButtonGroup/ToggleButtonGroup";

const Dataset = ({
  OpenDocUpload,
  setOpenDocUpload,
  setDatsetCount,
  showToaster,
  dataFromChild,
  handleOpenDocUpload,
  isAssistantDataset,
  datasetDetails, // Receive dataset details as a prop
  onDatasetSelect, // Callback to handle dataset selection
}) => {
  const dispatch = useDispatch();
  const { datasetId } = useParams();
  const { loading, addDataSetResponseData, error, AddDatasetStatus } =
    useSelector((state) => state.addDatasetReducer || {});
  const { response } = useSelector(
    (state) => state.getlistDatasetReducer || {}
  );
  const [open, setOpen] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [lengthError, setLengthError] = useState(true);
  const [specialChar, setSpecialChar] = useState(true);
  const [datasetExistError, setDatasetExistError] = useState("");
  const [data, setData] = useState([]);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const isMounted = useRef(true);
  const [filterDocdata, setfilterDocdata] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [LoaderFlag, setLoaderFlag] = useState(false);
  const [inputDiscriptionValue, setInputDiscriptionValue] = useState("");
  const [editDatasetFlag, setEditDatasetFlag] = useState(false);
  const [datasetType, setDatasetType] = useState("Non-Assistant"); // Default to Assistant type
  const [datasetTypeEnabled, setDatasetTypeEnabled] = useState(false); // Simple toggle state
  
const defaultChunkSize = '' ;
const defaultChunk = '';
const defaultChunkOverlap = '';
const defaultDocChunkEnabled = '';
const defaultNumList = '';
const defaultEmbeddingModel = '';
const defaultEmbeddingDeployment = '';
const defaultTrainingModel = '';
const defaultTrainingMethod = '';
const defaultImageSummarizationPrompt = '';
const defaultPageSummaryPrompt= '';
const defaultDocumentSummaryPrompt= '';
const initialPrompt = '';
const defaultCsvColumnsToExtract = ''; 
const initialKValue = '';
const initialThreshold = '';
const initialTemperature = '';
const initialModelName = '';
const initialMaxToken = '';
const initialQuestionPrompt = '';
const initialTopPValue = '';
const initialRegenerationPrompt = '';
const initialReranker = '';
 
  const getDataSet = () => {
    try {
      dispatch(getDatasets());
      setfilterDocdata(true);
    } catch (error) {
      console.error("Error in getting DataSet:", error);
    }
  };
 
  useEffect(() => {
    setIsButtonEnabled(false);
    if (OpenDocUpload) {
      setOpen(true);
    }
    if (isMounted.current) {
      dispatch(getDocumentSuccess([]));
      dispatch(DatasetUsersDataSuccess([]));
      getDataSet();
      isMounted.current = false;
    }
    if (addDataSetResponseData && filterDocdata) {
      const payload = {
      };
      const promptPayload = {
      };
      const assisPayload = {
        datasetId: addDataSetResponseData.id,
        openAIModel: process.env.REACT_APP_DEFAULT_MODEL_NAME || "gpt-4o-mini",
        temperature: parseFloat(process.env.REACT_APP_DEFAULT_TEMPERATURE) || 0.1,
        topP: parseFloat(process.env.REACT_APP_DEFAULT_TOP_P_VALUE) || 0.5,
        serviceAgentEnabled: false,
        chunkingStrategy: "auto",
        chunk: parseInt(process.env.REACT_APP_CHUNK, 10) || 800,
        chunkOverlap: parseInt(process.env.REACT_APP_CHUNK_OVERLAP, 10) || 320,
        systemInstructions: process.env.REACT_APP_DEFAULT_PROMPT || "",
      }
      if (AddDatasetStatus === 200) {
        showToaster(
          `"${addDataSetResponseData.datasetName}" added successfully`,
          "success"
        );
        if (datasetTypeEnabled) {
          dispatch(saveAssistantParameters(addDataSetResponseData.id, assisPayload));
        }
        if (!datasetTypeEnabled) {
          dispatch(createDocSettings(payload, addDataSetResponseData.id));
          dispatch(createPrompt(promptPayload, addDataSetResponseData.id)); // Save default values
        }
        setLoaderFlag(false);
        getDataSet();
        setfilterDocdata(false);
        setInputValue("");
        setInputDiscriptionValue("");
        handleClose();
        dispatch(AddRequestSuccess([]));
      } else {
        dispatch(AddRequestSuccess([]));
        setLoaderFlag(false);
        setOpen(true);
        setDatasetExistError("Dataset name already exists");
      }
    }
  }, [dispatch, addDataSetResponseData, OpenDocUpload, AddDatasetStatus]);
 
  useEffect(() => {
    if (deleteStatus) {
      getDataSet();
      setDeleteStatus(false);
    }
  }, [deleteStatus]);
 
  useEffect(() => {
    if (editDatasetFlag) {
      getDataSet();
      setEditDatasetFlag(false);
    }
  }, [editDatasetFlag]);
 
  useEffect(() => {
    if (response && response.length > 0) {
      setLoadingData(false);
      if (dataFromChild) {
        const fitleredData = response.filter((results) => {
          return results.datasetName
            .toString()
            .toLowerCase()
            .includes(dataFromChild);
        });
        if (fitleredData.length > 0) {
          setData(fitleredData);
        } else {
          setData([]);
        }
      } else {
        setData(response);
      }
    } else {
      setLoadingData(false); // Ensure loading is set to false if there is no response
      setData([]); // Explicitly set data to empty array if no response
    }
  }, [dataFromChild, response]);
 
  useEffect(() => {
    setIsButtonEnabled(false);
    if (response) {
      setDatsetCount(response.length);
      if (response.length > 0) {
        setData(response);
      }
    }
  }, [response, setDatsetCount]);
 
  const columns = [
    { id: "datasetName", label: "Dataset name" },
    { id: "files", label: "Documents" },
    { id: "accessUsers", label: "Users" },
    { id: "createdUTC", label: "Last updated" },
  ];
 
  const columnsSkelton = [
    { id: "datasetName", label: "Dataset name" },
    { id: "files", label: "Documents" },
    { id: "accessUsers", label: "Users" },
    { id: "createdUTC", label: "Last Updated" },
    { id: "action", label: "Action" },
  ];
 
  const handleClose = () => {
    setOpenDocUpload(false);
    setOpen(false);
    setDatasetExistError("");
    setInputValue("");
    setInputDiscriptionValue("");
    setSpecialChar(true);
    setDatasetTypeEnabled(false); // Reset the toggle state
  };
  const handleCloseFlag = () => {
    setOpenDocUpload(false);
    setOpen(false);
    setDatasetExistError("");
    setSpecialChar(true);
  };

  const handleDatasetTypeChange = (event, { value }) => {
    setDatasetType(value);
  };
 
  const handleDataSet = async () => {
   
    if (isButtonEnabled) {
      const requestData = {
        datasetName: inputValue,
        description: inputDiscriptionValue,
        isAssistantDataset: datasetTypeEnabled ? true : false, // Ensure boolean value is sent
        isReferenceDataset: false // Regular datasets are not reference datasets by default
      };
      dispatch(addDataSet(requestData));
      handleCloseFlag();
      setLoaderFlag(true);
      setfilterDocdata(true);
      setSpecialChar(true);
      
    }

  };
 
  const handleChange = (event) => {
    setDatasetExistError("");
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s'_\-()]/gi, "");
    setInputValue(value);
    const hasSpecialChar = value !== sanitizedValue;
    setSpecialChar(!hasSpecialChar);
    const isValidLength = sanitizedValue.length <= 50;
    setLengthError(isValidLength);
  
    if (isValidLength && !hasSpecialChar && value.trim().length > 0) {
      setIsButtonEnabled(true);
    } else {
      setIsButtonEnabled(false);
    }
  };
 
  const actions = [
    { key: "text", text: "Text Only", value: "text" },
    { key: "file", text: "File Only", value: "file" },
  ];

  const handleDatasetSelect = (dataset) => {
    onDatasetSelect(dataset); // Pass dataset details to parent (index.js)
  };
 
  return (
    <div>
      {/* mobile add dataset button */}
      <div className="hide-add-dataset-button-mobile">
        <Button
              primary
              onClick={handleOpenDocUpload}
              className="button-data-console"
              data-cy="add-dataset-btn-link"
              style={{ display: 'flex', alignItems: 'center',justifyContent: 'center'}} // ensures children are aligned
            >
              <Image
                src="/images/white-base-icons.svg"
                alt="Add new Dataset"
              />
              <span>Add new Dataset</span>
            </Button>
      </div>
      {/* end mobile dataset button */}
      {loadingData ? (
        <CardLoader numCards={20} />
      ) : data.length > 0 ? (
        <>
          <div>
            <DatasetLandingPage
              columns={columns}
              data={data}
              showToaster={showToaster}
              setDeleteStatus={setDeleteStatus}
              loaderFlag={LoaderFlag}
              setEditDatasetFlag={setEditDatasetFlag}
              setData={setData}  // Pass setData function here
              setDatsetCount={setDatsetCount}
              datasetTypeEnabled={datasetTypeEnabled} // Pass the toggle state as a prop
              isAssistantDataset={isAssistantDataset} // Pass the prop to DatasetLandingPage
              datasetDetails={datasetDetails} // Pass dataset details to DatasetLandingPage
              onDatasetSelect={handleDatasetSelect} // Pass callback
              />
          </div>
        </>
      ) : (
        <>
          <div className="emptyContainer">
            <Image src="/images/empty-state.svg" alt="Empty State" />
            <p className="emptyMessage">
              <span className="titleMessage">No data available </span>
              <span> Add your first dataset</span>
            </p>
          </div>
        </>
      )}
 
      <Modal
        open={open}
        onClose={handleClose}
        size="tiny"
        className="add-document-model"
      >
        <Modal.Content data-cy="error-message-cy">
          <Header as="h3">Add new dataset</Header>
          <label>Dataset name</label>
          <br />
          <Input
            type="text"
            value={inputValue}
            onChange={handleChange}
            placeholder="Add name"
            className="add-datset-input"
            data-cy="dataset-input-cy"
          />
          <br />
          {inputValue.length > 0 && !lengthError && (
            <span style={{ color: "red" }}>
              &nbsp;Maximum limit 50 characters.
            </span>
          )}
          {!specialChar && (
            <span style={{ color: "red" }}>
              &nbsp;Special characters are not allowed.
            </span>
          )}
          {inputValue.length > 0 && datasetExistError.length > 0 && (
            <span style={{ color: "red" }}>&nbsp;{datasetExistError}</span>
          )}
          <br />
          {/* <p className="add-dataset-description">Dataset Type</p> */}
          <p className="add-dataset-description">
            Enable Assistant Dataset
          </p>
          <div className="add-dataset-type-toggle">
            <ToggleButtonGroup
              isSimpleToggle={true}
              isEnabled={datasetTypeEnabled}
              onToggle={() => setDatasetTypeEnabled(!datasetTypeEnabled)}
              className="custom-toggle"
              dataCy="dataset-type-toggle"
            />
          </div>
          
          <br />
          <p className="add-dataset-description">Dataset Description</p>
          <div className="add-dataset-description-textarea">
            <textarea
              rows="4"
              cols="50"
              className="add-datset-input"
              data-cy="dataset-description-cy"
              onChange={(e) => setInputDiscriptionValue(e.target.value)}
            >
              {inputDiscriptionValue}
            </textarea>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <button
            className="cancel-btn"
            onClick={handleClose}
            data-cy="dataset-cancel-submit-btn"
          >
            Cancel
          </button>
          <button
            disabled={!isButtonEnabled}
            className="add-btn"
            onClick={handleDataSet}
            data-cy="dataset-submit-btn"
          >
            Add
          </button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};
 
export default Dataset;